<template>
	<el-dialog width="600px" :title="newOption.title" :visible.sync="newOption.value" @close="handleClose"  :close-on-click-modal="false" :close-on-press-escape="false">
		<div class="verification_con">
            <div class="verification_item">
                <p class="verification_label">安全验证</p>
                <div class="sendBox">
                    <el-input placeholder="请输入验证码" v-model="code"/>
                </div>
				<drag-verify
					ref="dragVerify"
					:width="240"
					:height="42"
					:text="codeTimes ? `重新发送${codeTimes}s` : newOption.text"
					handlerBg="#F5F5F5"
					successText="验证通过"
					handlerIcon="el-icon-d-arrow-right"
					successIcon="el-icon-circle-check"
					@passcallback="silderPasscallback"
				>
				</drag-verify>
            </div>
            <div class="decs" style="color: rgb(238, 167, 60);text-align:center;margin-top:12px" v-if="codeTimes"> 验证码已发送至{{phone}}，请在5分钟内输入</div>
        </div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="bindPhone" :disabled="!code">提交</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import { mapActions } from 'vuex'
	export default {
		props: {
			option: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				dialogTableVisible: false,
				defaultOptions: {
					value: false,
					title: '身份验证',
					text: '请按住滑块拖动'
				},
				timer: null,
				codeTimes: 0,
				code: '',
				phone: ''
			}
		},
		computed: {
			newOption: {
				get() {
					return {...this.defaultOptions,...this.option}
				},
				set(news) {

				}
			}
		},
		methods: {
			...mapActions('withdrawal', ['sendSms', 'checkSmsCode']),
			handleClose() {
				this.option.value = false
				// 为了解决点击关闭无效的bug
				this.code = '1'
				setTimeout(()=>{
					this.code = ''
				},20)
			},
			async silderPasscallback() {
				let res = await this.sendSms()
				this.phone = res.phone
				this.codeTimes = 60
				this.cutDown()
			},
            cutDown(){
				this.timer = setTimeout(() => {
					if(this.codeTimes > 0) {
						this.codeTimes--
						this.cutDown()
						this.codeTimes === 0 && this.$refs.dragVerify.reset();
					} else {
						clearTimeout(this.timer)
						
					}
				},1000)
			},
			async bindPhone() {
				await this.checkSmsCode({ code: this.code })
				localStorage.setItem('wattingTime',Date.now())
				this.option.value = false
				this.option.success()
				this.$message({
					type: 'success',
					duration: 3000,
					message: '验证成功'
				})
			}
		},
		beforeDestory() {
			clearTimeout(this.timer)
			this.timer = null
		}
	}
</script>
<style lang="less" scoped>
	.verification_con {
        width: 100%;
        .verification_item {
            display: flex;
            width: 100%;
            align-items: center;
            line-height: 40px;
            .verification_label {
                width: 100px;
                text-align: right;
                margin-right: 12px;
            }
            .sendBox {
                width: 140px;
                height: 40px;
                background: #fff;
                border-radius: 4px;
                border: 1px solid #c7cada;
                display: flex;
				margin-right: 12px;
                justify-content: space-between;
                align-items: center;
                position: relative;
                /deep/.el-input__inner {
                    border: none;
                }
                .sendBox_btn {
                    white-space: nowrap;
                    color: #4e70f2;
                    font-size: 12px;
                    width: 108px;
                    text-align: center;
                }
                .sendBox_line {
                    width: 1px;
                    height: 25px;
                    background: #dcdfe6;
                }
            }
        }
    }
</style>
